import axios from 'axios';

import { EMPLOYEE_NOTES, REMOVE_EMPLOYEE_NOTES } from 'RestAPIs/endpoints';

export interface EmployeeNotesProps {
  content: string;
  creationDate: string;
  creationEmployeeNumber: number;
  creationUser: string;
  flags: string[];
  noteId: number;
  refId: number;
  type: string;
}

export interface NewEmployeeNote {
  content: string;
}

export const getEmployeeNotes = (employeeId: number) =>
  axios.get<EmployeeNotesProps[]>(EMPLOYEE_NOTES, {
    pathParams: { employeeId }
  });

export const addEmployeeNote = (employeeId: number, body: NewEmployeeNote) =>
  axios.post<NewEmployeeNote>(EMPLOYEE_NOTES, body, {
    pathParams: { employeeId }
  });

export const removeEmployeeNote = (noteId: number) =>
  axios.delete(REMOVE_EMPLOYEE_NOTES, {
    pathParams: { noteId }
  });
